import { ErrorWrapper, ResponseWrapper } from "@/core/service/util";
import { RoomBaseApiService } from "@/core/service/room.baseapi.service";

export class RoomQuestionService extends RoomBaseApiService {

    async questionList() {
      try {
        const response = await this.request()
          .get(`/api/v3/room/${this.getRoomId()}/question/list`)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }
    
    async registerQuestion(params) {
      try {
        const response = await this.request()
          .post(`/api/v3/room/${this.getRoomId()}/question/register`, {
            ...params
          })
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    async deleteQuestion(params) {
        try {
            const response = await this.request()
                .post(`/api/v3/room/${this.getRoomId()}/question/delete`, {
                    ...params
                })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async setQuestion(params) {
      try {
        const response = await this.request({auth: true})
          .post(`/api/v3/room/${this.getRoomId()}/question/changeQuestionStatus`, {
            ...params
          })
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    // 질문 공개 여부 변경
    async changeQuestionOpenStatus(params) {
      try {
        const response = await this.request({auth: true})
          .post(`/api/v3/room/${this.getRoomId()}/question/info`, {
            ...params
          })
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    // 질문 좋아요
    async likeComments(params) {
      try {
        const response = await this.request({auth: true})
          .post(`/api/v3/room/${this.getRoomId()}/question/${params.questionId}/like`, {
            ...params
          })
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    // 질문 좋아요 취소
    async cancelLikeComments(params) {
      try {
        const response = await this.request({auth: true})
          .delete(`/api/v3/room/${this.getRoomId()}/question/${params.questionId}/like/${params.likeId}`)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    // 댓글 등록
    async postComment(params) {
      try {
        const response = await this.request({auth: true})
          .post(`/api/v3/room/${this.getRoomId()}/question/comment`, {
            ...params
          })
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    // 댓글 삭제
    async deleteComments(params) {
      try {
        const response = await this.request({auth: true})
          .post(`/api/v3/room/${this.getRoomId()}/question/comment/remove`, {
            ...params
          })
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

}

export const roomQuestionService = new RoomQuestionService()